/* eslint-disable no-restricted-imports */

export type {
  AmpathPatient,
  CreateOrderRequest,
  Guarantor,
  PathologyTestSearchResult,
} from './ampath';
export * as Ampath from './ampath';
export type {
  MedpraxCodeModel,
  MedpraxConsumableSearchParams,
  MedpraxDisciplineListResponse,
  MedpraxGetICD10ByCodesRequest,
  MedpraxGetICD10ByCodesResponse,
  MedpraxGetICD10ByCodesResponses,
  MedpraxGetMedicationsByCodesRequest,
  MedpraxGetMedicationsByCodesResponse,
  MedpraxGetMedicationsByCodesResponses,
  MedpraxIcd10AllResponse,
  MedpraxIcd10Search,
  MedpraxManagedCareCompany,
  MedpraxMedicationQueryParameters,
  MedpraxMedicationResponse,
  MedpraxMedicationSearchParams,
  MedpraxMedicationSearchResponse,
  MedpraxMedicationSearchResponses,
  MedpraxMedicationTokenResponse,
  MedpraxOption,
  MedpraxPage,
  MedpraxPageResponse,
  MedpraxPageResult,
  MedpraxPlan,
  MedpraxQualificationSearchRequest,
  MedpraxQueryParameters,
  MedpraxResolveSPOParams,
  MedpraxScheme,
  MedpraxSchemeAdministrator,
  MedpraxSchemesAdministratorAllResponse,
  MedpraxSchemesAdministratorResponse,
  MedpraxSchemesPlanOptionAllResponse,
  MedpraxSchemesPlanSubOptionAllResponse,
  MedpraxSchemesPlansAllResponse,
  MedpraxSchemesSchemeAllResponse,
  MedpraxSchemesSchemeResponse,
  MedpraxSPO,
  MedpraxSubOption,
} from './medprax';
export { MedpraxTariffMedicalTypeCode } from './medprax';
